/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_NothingInputs */

const en_today_nothing = /** @type {(inputs: Today_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cooking today`)
};

const de_today_nothing = /** @type {(inputs: Today_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute wird nicht gekocht`)
};

/**
* | output |
* | --- |
* | "No cooking today" |
*
* @param {Today_NothingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const today_nothing = /** @type {((inputs?: Today_NothingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_NothingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_today_nothing(inputs)
	return en_today_nothing(inputs)
});